import type { IReactionDisposer } from 'mobx';
import { reaction } from 'mobx';
import type { ISelectableItem, IBaseViewModel } from './interfaces';
import type { ViewsService } from './Views.service';
import type { IDisposable } from '@/engine/Utilities/IDisposable';
import type { CasePhaseData } from './CasePhaseData/CasePhaseData.ts';

export interface ISelectionReactionStrategy {
  reactOnSelection: (viewModel: ISelectableItem) => void;
}

export class PhaseViewItemsController implements IDisposable {
  private readonly _viewsService: ViewsService;

  private readonly _casePhaseData: CasePhaseData;

  private _changePhaseReactionDisposer: IReactionDisposer;

  public constructor(viewsService: ViewsService, casePhaseData: CasePhaseData) {
    this._viewsService = viewsService;
    this._casePhaseData = casePhaseData;

    const currentView = this._viewsService.currentView;
    if (!currentView) {
      throw new Error('Current view have to be defined');
    }

    this._changePhaseReactionDisposer = reaction(
      () => this._casePhaseData.getActivePhase(currentView.getImageStackDescriptor()).id,
      (phaseId) => {
        this._viewsService.views.forEach((view) => {
          const viewItems: Array<IBaseViewModel> = [...view.getObjects(), ...view.getMeasurements()];

          for (const viewItem of viewItems) {
            const isItemAvailable = viewItem.phaseId === phaseId || viewItem.phaseId === undefined;
            viewItem.setAvailability(isItemAvailable);
          }
        });
      }
    );
  }

  public dispose(): void {
    this._changePhaseReactionDisposer();
  }
}
